import React from 'react';
import { Shield, Truck, Phone, ArrowRight, Star } from 'lucide-react';
import { TestimonialCard } from './TestimonialCard';
export function ArticleSidebar() {
  return <aside className="space-y-8" data-id="element-7">
      {/* Product Highlight Card */}
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden" data-id="element-8">
        <div className="bg-[#1a4d2e] text-white text-center py-2 text-sm font-bold uppercase tracking-wider" data-id="element-9">
          Limited Time Offer
        </div>

        <div className="p-6" data-id="element-10">
          <img src="https://cdn.magicpatterns.com/uploads/5offfLTeCSzM6k6adpoefc/Generated_Image_February_05,_2026_-_11_35PM.jpg" alt="Lumera Gen-2™ Intelligent 3-in-1 Knee Therapy Device" className="w-full h-48 object-contain rounded mb-4" data-id="element-11" />

          <h3 className="font-serif text-xl font-bold text-[#2c2c2c] mb-2 text-center" data-id="element-12">
            Lumera Gen-2™
          </h3>
          <p className="text-center text-[#555] text-sm mb-4" data-id="element-13">
            Intelligent 3-in-1 Therapy System
          </p>

          <div className="flex justify-center items-baseline mb-6" data-id="element-14">
            <span className="text-3xl font-bold text-[#ff6b35]" data-id="element-15">RM999</span>
            <span className="ml-2 text-sm text-gray-400 line-through" data-id="element-16">
              RM1,299
            </span>
          </div>

          <a href="https://officiallumera.com/pages/lumera-3-1-knee-massager-1" target="_blank" rel="noopener noreferrer" className="w-full bg-[#ff6b35] hover:bg-[#ff5722] text-white font-bold py-3 px-4 rounded shadow-md transition-colors flex items-center justify-center group mb-4" data-id="element-17">
            Check Availability
            <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-18" />
          </a>

          <div className="space-y-3 text-xs text-[#555]" data-id="element-19">
            <div className="flex items-center" data-id="element-20">
              <Shield className="w-4 h-4 mr-2 text-[#1a4d2e]" data-id="element-21" />
              <span data-id="element-22">90-Day Money-Back Guarantee</span>
            </div>
            <div className="flex items-center" data-id="element-23">
              <Truck className="w-4 h-4 mr-2 text-[#1a4d2e]" data-id="element-24" />
              <span data-id="element-25">Free Express Delivery in Malaysia</span>
            </div>
            <div className="flex items-center" data-id="element-26">
              <Phone className="w-4 h-4 mr-2 text-[#1a4d2e]" data-id="element-27" />
              <span data-id="element-28">Local MY Support Team</span>
            </div>
          </div>
        </div>
      </div>

      {/* Sidebar Testimonial */}
      <div data-id="element-29">
        <h4 className="font-bold text-[#2c2c2c] uppercase tracking-wider text-sm mb-4 border-b border-gray-200 pb-2" data-id="element-30">
          Reader Feedback
        </h4>
        <TestimonialCard quote="My daughter bought this for me... Now I use it every night before bed. Best gift she ever got me." author="Puan Aminah" details="67, Cheras" compact={true} data-id="element-31" />
      </div>
    </aside>;
}